<span class='label'>Gas Fees</span>
<span class='amount'>
  <app-counter [value]='(transferFeeUSD$|async)!'></app-counter>
  @if (transferFee$|async; as feeTooltip) {
    <app-question-tooltip [text]='feeTooltip'></app-question-tooltip>
  }
</span>
